import { InjectionToken } from '@angular/core';
import { ServiceName } from '@shs-digi-care-monorepo/interfaces';

/**
 * Service whose translation files the editor reads and writes. Translation files are
 * stored per service in S3 (`translations/{serviceName}/{language}.json`), so each
 * frontend must pin the editor to the service that owns its translations.
 *
 * Override this token at the application root, e.g.
 * `{ provide: TRANSLATION_SERVICE_NAME, useValue: ServiceName.OmEmeaRequestService }`.
 */
export const TRANSLATION_SERVICE_NAME = new InjectionToken<ServiceName>('TRANSLATION_SERVICE_NAME', {
    providedIn: 'root',
    factory: () => ServiceName.RequestService
});
